var subwayScript = {
    ParseJsonOrDefault: function (jsonString, defaultValue) {
        var defaultVal = false;

        if (arguments.length === 2) {
            defaultVal = defaultValue;
        }

        if (jsonString == null) {
            return defaultVal;
        }

        try {
            var obj = JSON.parse(jsonString);

            if (obj && typeof obj === "object") {
                return obj;
            }
        } catch (e) { }

        return defaultVal;
    },
    isLocalStorageSupported: function (storageType) {
        var storage = storageType || "localStorage";
        var val = "__rotest__";

        try {
            var storageFn = window[storage];
            storageFn.setItem(val, val);
            var storedValue = storageFn.getItem(val);
            storageFn.removeItem(val);

            return storedValue === val;
        } catch (e) { }

        return false;
    },
};

subwayScript.IsEdit = 'isedit';
function setUserStoreCookie(data) {
    let countryCookie = []
    const getCookies = getCookie('userStoreData');
    const cookieData = {
        LocationId: {
            'StoreNumber': data.LocationId.StoreNumber,
            'SatelliteNumber': data.LocationId.SatelliteNumber,
            'Ordertype': orderViewModel.orderType,
            'Address': data.Address.Address1,
            'Country': orderViewModel.scLanguageCode
        }
    }
    if (!getCookies) {
        countryCookie.push(cookieData)
    }
    else {
        let index;
        countryCookie = getCookies;
        if (
          data.Address.StateProvCode && data.Address.StateProvCode.toLowerCase() === "pr" &&
          data.Address.CountryCode && data.Address.CountryCode.toLowerCase() === "us"
        ) {
          index =
            countryCookie.length > 0 &&
            countryCookie.findIndex(
              (resultData) =>
                resultData.LocationId.Country.toLowerCase() ===
                data.Address.StateProvCode.toLowerCase()
            );
        } else {
          index =
            countryCookie.length > 0 &&
            countryCookie.findIndex(
              (resultData) =>
                resultData.LocationId.Country.toLowerCase() ===
                data.Address.CountryCode.toLowerCase()
            );
        }
        if (index == -1) {
            countryCookie.push(cookieData)
        }
        else {
            countryCookie[index] = cookieData;
        }
    }
    if (orderViewModel.hasLoggedIn) {
        subwayScript.setCookie('isStoreChange', true, 90);
    }
    subwayScript.setCookie('userStoreData', JSON.stringify(countryCookie), 90);

}
function getCookie(cname) {
    let name = cname.toString() + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    let val = ca.find(x => x.trim().startsWith(name))
    let res = val && val.split('=')[1]
    return res ? JSON.parse(res) : false
}
function byUrlCulture() {
    return window.location.pathname.split('/')[1].split('-')[1].toLowerCase();
}
function getCookieByCountry() {
    const cookieData = getCookie('userStoreData');
    let cookieBycountry = cookieData
    if (cookieData && !orderViewModel.hasLoggedIn) {
        cookieBycountry = cookieData.length > 0 && cookieData.filter((data) => data.LocationId.Country.toLowerCase() == byUrlCulture());
        return cookieBycountry[0];
    }
    return null;
}
function storeChangeToDefault() {
    subwayScript.setCookie('isStoreChange', false, 90);
}



subwayScript.showGenericErrorMessage = function () {
    var $errorTitle = $("#modal-error #error-title");
    var $errorBody = $("#modal-error #error-body");

    var title = $errorTitle.data("fallbackErrorTitle");
    var body = $errorBody.data("fallbackErrorBody");

    $errorTitle.text(title);
    $errorBody.text(body);

    modalShowId("#modal-error");

    analytics.pageError(title, body);
};

subwayScript.showErrorMessage = function (model, suppressReportingError) {
    var errorDetails =
        model.responseText !== undefined ? $.parseJSON(model.responseText) : model;
    var $errorTitle = $("#modal-error #error-title");
    var $errorBody = $("#modal-error #error-body");
    if (
        errorDetails !== null &&
        errorDetails.Error !== undefined &&
        errorDetails.Error !== null &&
        errorDetails.Error.ErrorCode !== undefined &&
        errorDetails.Error.ErrorCode !== null
    ) {
        if (errorDetails.Error.ErrorCode.toLowerCase() === "dord-3003") {
            var title = errorDetails.Error.Title;
            var message = errorDetails.Error.Message;
            var childCode = errorDetails.Error.ErrorCode || "n/a";
            var parentCode = errorDetails.Error.ParentCode || "n/a";
            $("#cart-expiry-title").text(title);
            $("#cart-expiry-message").text(message);
            subwayScript.hideSpinner();
            subwayScript.hideSpinner1();
            modalShowId("#cart-expiry-modal");
            if (!suppressReportingError) {
                analytics.pageError(title, message, parentCode, childCode, true);
            }
            return {
                title: title,
                body: message,
            };
        } else {
            var $errorTitle = $("#modal-error #error-title");
            var $errorBody = $("#modal-error #error-body");

            if (!model || !model.Error) {
                subwayScript.showGenericErrorMessage();
                return false;
            }

            var title = model.Error.Title || $errorTitle.data("fallbackErrorTitle");
            var body = model.Error.Message || $errorBody.data("fallbackErrorBody");
            var childCode = model.Error.ErrorCode || "n/a";
            var parentCode = model.Error.ParentCode || "n/a";
            $errorTitle.text(title);
            $errorBody.text(body);
            modalShowId("#modal-error");
            if (!suppressReportingError) {
                analytics.pageError(title, body, parentCode, childCode, true);
            }
            return {
                title: title,
                body: body,
            };
        }
    } else {
        var $errorTitle = $("#modal-error #error-title");
        var $errorBody = $("#modal-error #error-body");

        if (!model || !model.Error) {
            subwayScript.hideSpinner();
            subwayScript.hideSpinner1();
            subwayScript.showGenericErrorMessage();
            return false;
        }

        var title = model.Error.Title || $errorTitle.data("fallbackErrorTitle");
        var body = model.Error.Message || $errorBody.data("fallbackErrorBody");
        var childCode = model.Error.ErrorCode || "n/a";
        var parentCode = model.Error.ParentCode || "n/a";
        $errorTitle.text(title);
        $errorBody.text(body);
        subwayScript.hideSpinner();
        subwayScript.hideSpinner1();
        modalShowId("#modal-error");
        if (!suppressReportingError) {
            analytics.pageError(title, body, parentCode, childCode, true);
        }
        return {
            title: title,
            body: body,
        };
    }
    return {
        title: title,
        body: body,
    };
};

subwayScript.showAjaxError = function (jqXhr, suppressReportingError) {
    var errorModel = subwayScript.ParseJsonOrDefault(
        jqXhr.responseText == undefined ? JSON.stringify(jqXhr) : jqXhr.responseText
    );
    subwayScript.hideSpinner();
    subwayScript.hideSpinner1();
    return subwayScript.showErrorMessage(errorModel, suppressReportingError);
};

subwayScript.isMaxProteinReached = function () {
    if (orderViewModel.currentOrder.cartQuantity !== "") {
        var sidesOrDrinksQty =
            orderViewModel.currentOrder.sidesDrinksQuantity !== undefined
                ? orderViewModel.currentOrder.sidesDrinksQuantity
                : 0;
        var proteinQty =
            parseInt(orderViewModel.currentOrder.cartQuantity) - sidesOrDrinksQty;
        if (
            orderViewModel.store.maxProteinsForExpressOrder !== null &&
            orderViewModel.store.maxProteinsForExpressOrder !== 0 &&
            proteinQty >= orderViewModel.store.maxProteinsForExpressOrder
        ) {
            $("#modal-error #error-title").text(maxProteinModalTitle);
            $("#modal-error #error-body").text(
                maxProteinModalMessage.replace("{{QUANTITY}}", proteinQty)
            );
            modalShowId("#modal-error");
            return true;
        }
    }
    return false;
};

subwayScript.showSpinner = function () {
    $("#subway-spinner").show();
};

subwayScript.showSpinner1 = function () {
    $("#subway-spinner1").show();
};

subwayScript.hideSpinner = function () {
    $("#subway-spinner").hide();
};
subwayScript.reactHideSpinner = function () {
    $("#subway-react-spinner").hide();
};

subwayScript.hideSpinner1 = function () {
    $("#subway-spinner1").hide();
};
subwayScript.createCache = function (requestFunction) {
    var cacheStorageKey = "rocache";

    if (!subwayScript.cache) {
        var cache = localStorage.getItem(cacheStorageKey);

        if (cache) {
            subwayScript.cache = subwayScript.ParseJsonOrDefault(cache) || {};
        } else {
            subwayScript.cache = {};
        }
    }

    return function (key, callback) {
        if (!subwayScript.cache[key]) {
            subwayScript.cache[key] = $.Deferred(function (defer) {
                requestFunction(defer, key);
            }).promise();

            localStorage.setItem(cacheStorageKey, JSON.stringify(subwayScript.cache));
        }

        return subwayScript.cache[key].done(callback);
    };
};

subwayScript.checkSatelliteNumber = function (ID) {
    if (ID != null) {
        const checkSatelliteNumber = ID.toString().split("-");
        if (checkSatelliteNumber.length > 1) {
        return ID;
        }
     return ID + "-0";
    }
};

subwayScript.crossDomainAjax = function (url, success) {
    var xdr;
    var dom;
    var json;

    if (typeof success !== "function") {
        success = Function.prototype;
    }

    if ("XDomainRequest" in window && window.XDomainRequest !== null) {
        var deferred = $.Deferred();
        xdr = new XDomainRequest();
        xdr.ontimeout = function () { };
        xdr.onprogress = function () { };
        xdr.open("get", url);

        xdr.onload = function () {
            dom = new ActiveXObject("Microsoft.XMLDOM");

            json = subwayScript.ParseJsonOrDefault(xdr.responseText);

            dom.async = false;

            if (json == null || typeof json === "undefined") {
                var newJsonBody =
                    (xdr.responseText &&
                        xdr.responseText.firstChild &&
                        xdr.responseText.firstChild.textContent) ||
                    null;

                json = subwayScript.ParseJsonOrDefault(newJsonBody);
            }

            if (json) {
                success(json);
                deferred.resolve();
            } else {
                modalClose(true);
                subwayScript.showGenericErrorMessage();
                deferred.reject();
            }
        };

        xdr.onerror = function () {
            deferred.reject();
            modalClose(true);
            subwayScript.showGenericErrorMessage();
        };

        xdr.send();

        return deferred.promise();
    } else if (
        navigator.userAgent.indexOf("MSIE") !== -1 &&
        parseInt(navigator.userAgent.match(/MSIE ([\d.]+)/)[1], 10) < 8
    ) {
        //IE7 and below cannot source CORS
        return $.Deferred().reject().promise();
    } else {
        return $.ajax({
            url: url,
            success: success,
            cache: true,
            error: function (jqXhr) {
                modalClose(true);

                subwayScript.showAjaxError(jqXhr);
            },
        });
    }
};

var navigationUrls = subwayScript.ParseJsonOrDefault(
    $("#navigationUrls").val()
);

subwayScript.navigation = {
    urls: navigationUrls,
    getLanguageCode: function () {
        var $language = $("#scLanguageCode");

        if (!$language.length) {
            return "";
        }

        var language = $language.val();
        if (!language) {
            return "";
        }

        return "/" + language;
    },
};

subwayScript.navigation.getCustomizerUrl = function (
    restaurantId,
    productSummaryId,
    productId,
    categoryId
) {
    var url =
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.CustomizerUrl;

    return url
        .replace("{restaurantid}", subwayScript.checkSatelliteNumber(restaurantId))
        .replace("{productsummaryid}", productSummaryId)
        .replace("{productid}", productId)
        .replace("{categoryid}", categoryId);
};

subwayScript.navigation.getDeliveryStatusUrl = function (orderId) {
    var url =
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.DeliveryOrderStatusUrl;
    return url.replace("{orderId}", orderId);
};

subwayScript.navigation.getOrderConfirmationPageUrl = function (orderId) {
    var url =
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.OrderConfirmationPageUrl;
    return url.replace("{orderId}", orderId);
};
subwayScript.navigation.getMenuUrlCartExpire = function (restaurantid) {
    var url =
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.MenuUrlCartExpire;
    return url.replace("{restaurantid}", subwayScript.checkSatelliteNumber(restaurantid));
};

subwayScript.navigation.getCartItemCustomizerUrl = function (
    restaurantId,
    cartId,
    cartItemId,
    categoryId,
    language
) {
    var url = "/" + subwayScript.navigation.urls.CustomizerCartItemUrl;

    return url
        .replace("{restaurantid}", subwayScript.checkSatelliteNumber(restaurantId))
        .replace("{cartid}", cartId)
        .replace("{cartitemid}", cartItemId)
        .replace("{language}", language)
        .replace("{categoryId}", categoryId);
};

subwayScript.navigation.getLocatorUrl = function () {
    return (
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.LocatorUrl
    );
};

subwayScript.navigation.getDealsPageUrl = function () {
    return (
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.DealsPgeUrl
    );
};

subwayScript.navigation.getDeliveryLocatorUrl = function () {
    return (
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.DeliveryLocatorUrl
    );
};

subwayScript.navigation.getRecentOrderDeliveryLocatorUrl = function (cartid) {
    var url =
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.RecentOrderDeliveryLocatorUrl;
    return url.replace("{cartid}", cartid);
};

subwayScript.navigation.getMenuCategoryListingUrl = function (
    languageCode,
    restaurantId,
    categoryId
) {
    var url = subwayScript.navigation.urls.MenuCategoryListingUrl;

    return url
        .replace("{language}", languageCode)
        .replace("{restaurantid}", subwayScript.checkSatelliteNumber(restaurantId))
        .replace("{categoryid}", categoryId);
};

subwayScript.navigation.getMenuProductListingUrl = function (
    restaurantId,
    categoryId,
    productId
) {
    var url =
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.MenuProductListingUrl;

    return url
        .replace("{restaurantid}", subwayScript.checkSatelliteNumber(restaurantId))
        .replace("{categoryid}", categoryId)
        .replace("{productid}", productId);
};

subwayScript.navigation.getMenuUrl = function (restaurantId) {
    var satelliteCheck = subwayScript.checkSatelliteNumber(restaurantId)
    var url = subwayScript.navigation.urls.MenuUrl;
    return url
        .replace("{restaurantid}", satelliteCheck)
        .replace("{language}", subwayScript.navigation.getLanguageCode());
};

subwayScript.navigation.getStoreMenu = function () {
    var id = window.orderViewModel.store.id;
    if (id !== null) {
        return subwayScript.navigation.getMenuUrl(id);
    }
    return subwayScript.navigation.getMenuUrl(1);
};

subwayScript.navigation.getOrderHistoryUrl = function () {
    return (
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.OrderHistoryUrl
    );
};

subwayScript.navigation.getOrderManagementUrl = function () {
    return (
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.OrderManagementUrl
    );
};
subwayScript.navigation.getRewardsActivityTestUrl = function () {
    return (
        subwayScript.navigation.getLanguageCode() +
        "/profile/rewards-activity"
    );
};

subwayScript.navigation.getMyFavoritesUrl = function () {
    var url =
        subwayScript.navigation.getLanguageCode() +
        "/" +
        subwayScript.navigation.urls.myFavoritesUrl;

    return url.replace("/{0}/", '');
};

subwayScript.getStoreId = function (restaurantId, satelliteNumber) {
    if (restaurantId === "" && satelliteNumber === "") {
        restaurantId = orderViewModel.store.storeNumber;
        satelliteNumber = orderViewModel.store.satelliteNumber;
    }
    var satelliteNo = parseInt(satelliteNumber) || 0;
    if (!isNaN(satelliteNo) && !isNaN(restaurantId)) {
      return `${restaurantId}-${satelliteNo}`;
    }
    if (restaurantId.toString().includes("-")) {
      return `${restaurantId.toString().split("-")[0]}-${satelliteNo}`;
    }
    return `${restaurantId}-${satelliteNo}`;
};

subwayScript.showLocationRequiredModal = function (redirectURL) {
    if (redirectURL === undefined || redirectURL === "") {
        redirectURL = window.location.pathname;
    }
    var locatorUrl =
        subwayScript.navigation.getLocatorUrl() + "?redirectURL=" + redirectURL;
    $("#location-modal-confirm").attr("href", locatorUrl);
    modalShowId("#modal-location-missing");
};

subwayScript.bindPageTitle = function () {
    var dynamicTitle = "";
    var modelTitle = orderViewModel.modelTitle || "";
    var globalTitle = orderViewModel.globalTitle || "";
    switch (orderViewModel.ScContext.itemTemplateID) {
        case orderViewModel.ScTemplate.menuTemplateID:
        case orderViewModel.ScTemplate.poductListTemplateID:
            if (orderViewModel.store.address != null) {
                dynamicTitle =
                    orderViewModel.store.address + orderViewModel.titleSeparator;
            }
            break;
        case orderViewModel.ScTemplate.productTemplateID:
        case orderViewModel.ScTemplate.customizerTemplateID:
            if (orderViewModel.currentOrder.productName != null) {
                dynamicTitle =
                    orderViewModel.currentOrder.productName +
                    orderViewModel.titleSeparator;
            }
            break;
        case orderViewModel.ScTemplate.restaurantTemplateID:
            if (orderViewModel.store.address1 != null) {
                dynamicTitle =
                    orderViewModel.store.address1 + orderViewModel.titleSeparator;
            }
            break;
        default:
            dynamicTitle;
    }
    document.title = modelTitle + dynamicTitle + globalTitle;
};

subwayScript.setCookie = function (name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + "; path=/";
};

subwayScript.getCookie = function (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

subwayScript.updateStoreDetails = function (storeData) {
    orderViewModel.store.id = subwayScript.checkSatelliteNumber(storeData.StoreId);
    orderViewModel.store.languageCode = storeData.LanguageCode;
    if (storeData.address !== null) {
        orderViewModel.store.address = storeData.Address.StreetAddress1;
        orderViewModel.store.address1 = storeData.Address.StreetAddress1;
        orderViewModel.store.city = storeData.Address.City;
        orderViewModel.store.stateProvCode = storeData.Address.State;
        orderViewModel.store.postalCode = storeData.Address.Zip;
        if (storeData.Address.Country !== null) {
            orderViewModel.store.storeCountry = storeData.Address.Country;
        }
    }
    orderViewModel.store.countryCode = storeData.CountryCode.toLowerCase();
    orderViewModel.store.phoneNumber = storeData.TelephoneNumber;
    orderViewModel.store.maxProteinsForExpressOrder =
        storeData.MaxProteinsForExpressOrder;
    orderViewModel.store.StoreId = subwayScript.checkSatelliteNumber(storeData.LocationId);
    orderViewModel.save();
    subwayScript.bindPageTitle();
    compNavLocation.Bind();
    analytics.setStoreID();
};

subwayScript.reactUpdateStoreDetails = function (storeData) {
    const locationNumber = storeData.locationId ? storeData.locationId.split('-') : []
    const storeNumber = storeData.storeId ? storeData.storeId.split('-') : [] 
    orderViewModel.store.id = subwayScript.checkSatelliteNumber(storeData.locationId || storeData.storeId); 
    orderViewModel.store.languageCode = storeData.languageCode;
    if (storeData.address !== null) {
        orderViewModel.store.address = storeData.address.streetAddress1;
        orderViewModel.store.address1 = storeData.address.streetAddress1;
        orderViewModel.store.city = storeData.address.city;
        orderViewModel.store.stateProvCode = storeData.address.state;
        orderViewModel.store.postalCode = storeData.address.zip;
        if(storeData.languageCode){
            orderViewModel.store.languageCode = storeData.languageCode.substring(0, 2);
        }
        if (storeData.address.country !== null) {
            orderViewModel.store.storeCountry = storeData.address.country;
        }
    }
    orderViewModel.store.storeNumber = storeNumber.length > 0 ? storeNumber[0] : locationNumber[0] || '';
    orderViewModel.store.satelliteNumber = storeNumber.length > 1 ? storeNumber[1] : locationNumber[1] || '';
    if(storeData.countryCode){
        orderViewModel.store.countryCode = storeData.countryCode.toLowerCase();
    }
    orderViewModel.store.phoneNumber = storeData.telephoneNumber;
    orderViewModel.store.maxProteinsForExpressOrder =
        storeData.maxProteinsForExpressOrder;
    orderViewModel.store.StoreId = subwayScript.checkSatelliteNumber(storeData.locationId);
    if (orderViewModel.orderType == null) {
        orderViewModel.orderType = 'pickup'
    }
    orderViewModel.save();
    subwayScript.bindPageTitle();
    compNavLocation.Bind();
    analytics.setStoreID();
};

subwayScript.updateFavStore = function (storeData) {
    orderViewModel.favStore.address1 = storeData.Address.Address1;
    orderViewModel.favStore.address3 = storeData.Address.Address3;
    orderViewModel.save();
};

subwayScript.bindModalToLastFocus = function (e, lastFocus, modalId) {
    var modelTag = modalId + " .btn-close";
    setTimeout(function () {
        $("#" + modelTag).focus();
    }, 500);
    $("#" + modelTag).on("keydown", function (e) {
        if (e.type === "click" || e.which === 13) {
            setTimeout(function () {
                lastFocus.focus();
            }, 500);
        }
    });
    $(document).keyup(function (e) {
        if (e.key === "Escape" || e.key === "Esc") {
            // escape key maps to keycode `27`
            setTimeout(function () {
                lastFocus.focus();
            }, 500);
        }
    });
};

subwayScript.isDashboard = function () {
    return $(".welcome-content").length > 0;
};

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", 'i'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function redirectToLanguageContext(langCode) {
    var paths = window.location.pathname.split("/");
    paths.shift();
    //matching the url language with 5 character length as per the current language code from sitecore.
    if (paths[0].match("[a-z]{2}-[A-Za-z]{2}")) {
        paths[0] = langCode;
    }
    window.location.href = window.location.origin + "/" + paths.join("/");
}

(function (w) {
    w.URLSearchParams =
        w.URLSearchParams ||
        function (searchString) {
            var self = this;
            self.searchString = searchString;
            self.get = function (name) {
                var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
                    self.searchString
                );
                if (results === null) {
                    return null;
                } else {
                    return decodeURI(results[1]) || null;
                }
            };
        };
})(window);

Math.trunc =
    Math.trunc ||
    function (value) {
        if (isNaN(value)) {
            return value;
        }
        if (value > 0) {
            return Math.floor(value);
        }
        return Math.ceil(value);
    };

// Polyfill - 'endsWith' method for IE
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, position) {
        var subjectString = this.toString();
        if (
            typeof position !== "number" ||
            !isFinite(position) ||
            Math.floor(position) !== position ||
            position > subjectString.length
        ) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

function isMobileTablet() {
    return window.innerWidth <= 1024;
}

function isKidsMealProduct() {
    return sessionStorage.getItem("isKidsMeal") === "true" || false;
}

function isEmptyCheck(property) {
    if (!property) {
        return true;
    }
    if (typeof property == "object") {
        return Object.keys(property).length === 0;
    }
}

const sizeNames = [
    "footlong",
    '6"',
    "6''",
    "footlong pro",
    "12 po",
    "6 po",
    "fl pro",
];

const getSizeName = (productName = '', isSideOrDrink = false) => {
    if (isSideOrDrink) return productName;
    const sizename = sizeNames.filter((v) => {
        return productName.toLowerCase().indexOf(v) >= 0;
    });
    return sizename.length > 0 ? sizename[0] : "n/a";
};

const getDomainName = () => {
    const url = window.location.href.toLowerCase();
    let source = "";
    const urlArray = url.split(/[#?]/)[0].split('/');
    source = urlArray[2].includes('order') ? 'order' : 'subway';
    return source;
}

function handleImageLoadnew(imgElement){
    imgElement.classList.remove('loading');
    imgElement.classList.remove('largeloader');
}

function getQueryParamsId(flag){
    const url = window.location.href.toLowerCase();

    if(flag){
        const queryParam = flag.toLowerCase();
        if (url.includes(queryParam)) {
            const value = new URL(url).searchParams.get(queryParam);
            return value;
        }
    }
}